import { useEffect, useState } from 'react';
import { TbMessage2Share } from 'react-icons/tb';
import Swal from 'sweetalert2';

const ContactForm = () => {
  const [messageSent, setMessageSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const data = {};
    formData.forEach((value, key) => {
      data[key] = value;
    });

    try {
      const response = await fetch('https://portfolio-server-five-omega.vercel.app/api/submit-message', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        Swal.fire({
          icon: 'success',
          confirmButtonColor: "#FFA001",
          title: 'Message Sent',
          text: 'Your message has been sent successfully.',

        });
        setMessageSent(true);
        e.target.reset(); // Clear the form after successful submission
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Failed to Send Message',
          text: 'Please try again later.',
        });
      }
    } catch (error) {
      console.error('Error sending message:', error);
      Swal.fire({
        icon: 'error',
        title: 'Failed to Send Message',
        text: 'Please try again later.',
      });
    }
  };

    return (
      <form className='contactUs' onSubmit={handleSubmit}>
        <div class="md:flex items-center mt-12">
          <div class="w-full md:w-1/2 flex flex-col">
            <label class="font-semibold leading-none text-gray-300">Name</label>
            <input
              type="text"
              required
              name='name'
              class="leading-none text-gray-50 p-3 focus:outline-none focus:border-blue-700 mt-4 border-0 bg-gray-800 rounded"
            />
          </div>
          <div class="w-full md:w-1/2 flex flex-col md:ml-6 md:mt-0 mt-4">
            <label class="font-semibold leading-none text-gray-300">Email</label>
            <input
              type="email"
              required
              name='email'
              class="leading-none text-gray-50 p-3 focus:outline-none focus:border-blue-700 mt-4 border-0 bg-gray-800 rounded"
            />
          </div>
        </div>
        <div class="md:flex items-center mt-8">
          <div class="w-full flex flex-col">
            <label class="font-semibold leading-none text-gray-300">Subject</label>
            <input
              type="text"
              required
              name='subject'
              class="leading-none text-gray-50 p-3 focus:outline-none focus:border-blue-700 mt-4 border-0 bg-gray-800 rounded"
            />
          </div>
        </div>
        <div>
          <div class="w-full flex flex-col mt-8">
            <label class="font-semibold leading-none text-gray-300">Message</label>
            <textarea
              type="text"
              required
              name='message'
              class="h-40 text-base leading-none text-gray-50 p-3 focus:outline-none focus:border-blue-700 mt-4 bg-gray-800 border-0 rounded"
            ></textarea>
          </div>
        </div>
        <div className="flex items-center justify-center w-full">
        <button
          type="submit"
          className="contact-button border-2 border-primary hover:before:bg-primary my-6"
          data-aos-duration="5500"
          data-aos-easing="ease-in-out"
          data-aos="zoom-in"
          disabled={messageSent} // Disable the button after sending the message
        >
          <span>{messageSent ? 'Message Sent' : 'Send Message'}</span>
          <span className="button-icon bg-primary">
            <TbMessage2Share/>
          </span>
        </button>
      </div>
      </form>
    );
  };

  export default ContactForm;